import React from "react";
import { Chat as IChat, ChatType, ParticipantType } from "../GeneratedTypes";
import { Typography, Avatar, useTheme } from "@material-ui/core";
import { Localizations, ObserverLocalizations, MentorLocalizations } from "../sharedTypes";
import moment from "moment";

interface PropTypes {
    chat: IChat;
    isMine: boolean;
    participantType: ParticipantType;
    clientLocalizations?: Localizations;
    mentorLocalizations?: MentorLocalizations;
    observerLocalizations?: ObserverLocalizations;
}
export default function ChatMessage(
    {
        chat,
        isMine,
        participantType,
        clientLocalizations,
        mentorLocalizations,
        observerLocalizations
    }: PropTypes) {
    const theme = useTheme();
    const localizations = mentorLocalizations ?? clientLocalizations ?? observerLocalizations;

    function getExtraText() {
        switch (chat.chatType) {
            case ChatType.Internal:
                return localizations?.internalMessage ?? "(Internal)";
            case ChatType.Private:
                return isMine ? chat.toDisplay : localizations?.privateMessage ?? "(Private)";
            case ChatType.Mentee:
                return chat.toDisplay;
            case ChatType.Public:
                return participantType !== ParticipantType.Client ? localizations?.publicMessageEveryone ?? "(Everyone)" : "";
            default:
                return "";
        }
    }

    function getName() {
        return chat.authorFirstName
            + ' ' + chat.authorLastName
            + ' ' + (chat.authorTitle ? ' - ' + chat.authorTitle : ' ')
    }

    function getRole() {
        switch (chat.authorType) {
            case ParticipantType.Client:
                return localizations?.menteeRole ?? "(Mentee)";
            case ParticipantType.Mentor:
                return localizations?.mentorRole ?? "(Mentor)";
            case ParticipantType.Observer:
                return localizations?.internalObserverRole ?? "(Internal Observer)";
            case ParticipantType.ExternalObserver:
                return localizations?.externalObserverRole ?? "(External Observer)";
            default:
                return "";
        }
    }

    const outgoingMessageStyles = {
        display: "flex",
        justifyContent: "flex-end",
        width: "50%",
        marginLeft: "auto",
        textAlign: "right" as const
    };

    const incomingMessageStyles = {
        flex: 1,
        margin: '5px 66px',
        width: "50%"
    };

    // <Slide direction="left" in={true}>
    if (!isMine) {
        return (
            <>
                <div style={incomingMessageStyles}>
                    <Typography variant="caption">
                        {getName()} {getRole()} {getExtraText() + " - " + moment(chat.sentUTC).format("h:mm:ss A")}
                    </Typography>
                </div>
                <div style={{ display: "flex" }}>
                    <Avatar src={chat.authorPhotoUrl} sizes="" style={{ marginRight: 16 }}></Avatar>
                    <div style={{ margin: "5px 10px", border: "2px solid #ccc", borderRadius: 20, padding: 10 }}>
                        <Typography variant="body2">{chat.text}</Typography>
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div style={outgoingMessageStyles}>
                    <div>
                        <Typography variant="caption">
                            {
                                getExtraText() +
                                (getExtraText()?.length ?? 0 > 0 ? " - " : "") +
                                moment(chat.sentUTC).format("h:mm:ss A")}
                        </Typography>
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>

                    <div
                        style={{
                            margin: "5px 10px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: 20,
                            padding: 10,
                        }}
                    >
                        <Typography variant="body2">{chat.text}</Typography>
                    </div>
                </div>
            </>
        );
    }
}
